import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale } from "chart.js";
import { FaUserCircle } from "react-icons/fa";
import { Card, CardContent } from "../components/ui/card";
import BalanceCard from "./BalanceCard";
import Menu from './menu';
import axios from '../axiosInstance';
import { FaTelegramPlane, FaFacebookF, FaXTwitter } from "react-icons/fa6";
import rollercoinBanner from "../assets/images/bannerRollerCoin.gif"; // RollerCoin banner image
import logoBanner from "../assets/images/new_logo_without_font.png";
import HighPerformanceAd from "../components/HighPerformanceAd";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import KpiCards from "../components/KpiCards";
import { Footer } from "../components/ Footer";

// Initialize ChartJS components
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

// Main component for the Marketplace page
export default function OptionHolderPage({ onLogout }) {
  const [options, setOptions] = useState(0); // Options available in the marketplace
  const [coinz, setCoinz] = useState(0); // User's COINZ balance
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0); // User's own weekly earnings
  const [balance, setBalance] = useState(300); // User balance (unused here)
  const [username, setUsername] = useState(null);
  const [topOptions, setTopOptions] = useState([]); // Top 100 option holders
  const [dividends, setDividends] = useState([]);
  const [weeklyProfit, setWeeklyProfit] = useState(0); // Global weekly earnings

    function CountdownToSunday() {
    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {
      const updateCountdown = () => {
        const now = new Date();
        const nextSunday = new Date(now);
        nextSunday.setDate(now.getDate() + ((7 - now.getDay()) % 7));
        nextSunday.setHours(23, 30, 0, 0);

        // If it's already passed today
        if (now.getDay() === 0 && now > nextSunday) {
          nextSunday.setDate(nextSunday.getDate() + 7);
        }

        const diff = nextSunday - now;
        const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, "0");
        const hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0");
        const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
        const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

        setTimeLeft(`${days}:${hours}:${minutes}:${seconds}`);
      };

      updateCountdown();
      const intervalId = setInterval(updateCountdown, 1000);
      return () => clearInterval(intervalId);
    }, []);

    return (
      <div className="mt-6 text-center bg-gray-900 border border-gray-700 rounded-lg p-4 shadow-inner">
        <p className="text-gray-400 mb-1 uppercase tracking-wide">Next dividend Batch</p>
        <div className="text-3xl font-mono font-bold text-green-400 tracking-widest">{timeLeft}</div>
        <p className="text-xs text-gray-500 mt-2">Every Sunday at 11:30 PM</p>
      </div>
    );
  }

  // Fetch the latest dividends
  const getDividends = () => {
    axios
      .get(`/api/last-dividends`)
      .then((response) => {
        setDividends(response.data);
      })
      .catch((error) => {
        console.error("Error fetching dividends:", error);
      });
  };

  // Fetch top 100 option holders
  const getTopOptions = () => {
    axios
      .get(`/api/top-options`)
      .then((response) => {
        setTopOptions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching top users:", error);
      });
  };



  // 📡 Fetch user data via API
  const getUserData = () => {
   
    axios
      .get(`/api/user/me`, { withCredentials: true })
      .then((response) => {
        const { coinz, options, systemCoinz, weeklyProfit, username } = response.data;
        const valeurCalculee = options > 0 ? (( systemCoinz / weeklyProfit) * options) : 0;  // On évite la division par 0
		setSelfWeeklyProfit(valeurCalculee);
        setCoinz(coinz);
        setOptions(options);
        setWeeklyProfit(weeklyProfit);
        setUsername(username);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  };

  useEffect(() => {
    document.title = "OptionHolders | CoinzUp";
	getUserData()
    getTopOptions();
    getDividends();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gray-900 text-white font-sans">
      {/* Contenu principal avec sidebar */}
      <div className="flex flex-1 min-h-[calc(100vh-64px)]">
        {/* Sidebar pleine hauteur */}
        <Sidebar onLogout={onLogout}/>
  
        {/* Contenu à droite */}
        <main className="flex-1 px-4 sm:px-10 py-8 space-y-10 overflow-auto min-w-0">
        <Header title="Options holders"  balance={coinz}        optionsOwned={options}        estimatedWeeklyGain={selfWeeklyProfit} />

          <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90} />
          

           {/* Dividends Latest Table */}
           <section className="max-w-5xl mx-auto bg-gray-800 p-5 rounded-lg border border-gray-700 shadow-sm text-gray-300 overflow-auto">
            <h2 className="text-xl font-semibold mb-6 text-white tracking-wide">Latest Distributed Dividends</h2>
            <table className="min-w-full table-auto border-collapse border border-gray-600">
              <thead className="bg-gray-700">
                <tr>
                  <th className="py-3 px-4 border border-gray-600 text-left text-sm font-medium text-gray-100 uppercase tracking-wide">Date</th>
                  <th className="py-3 px-4 border border-gray-600 text-left text-sm font-medium text-gray-100 uppercase tracking-wide">Description</th>
                  <th className="py-3 px-4 border border-gray-600 text-right text-sm font-medium text-gray-100 uppercase tracking-wide">Amount</th>
                </tr>
              </thead>
              <tbody>
                {dividends.map((dividend, index) => (
                  <tr
                    key={dividend.id}
                    className={`border border-gray-700 ${index % 2 === 0 ? "bg-gray-900" : "bg-gray-800"}`}
                  >
                    <td className="py-2 px-4 text-sm">{new Date(dividend.date).toLocaleDateString()}</td>
                    <td className="py-2 px-4 text-sm">{dividend.description || "Weekly Distribution"}</td>
                    <td className="py-2 px-4 text-sm text-right font-mono text-green-400">+{parseFloat(dividend.amount).toFixed(3)} COINZ</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          {/* Top 100 Option Holders Table */}
          <section className="max-w-5xl mx-auto bg-gray-800 p-5 rounded-lg border border-gray-700 shadow-sm text-gray-300 overflow-auto">
            <h2 className="text-xl font-semibold mb-6 text-white tracking-wide">Top 100 Option Holders</h2>
            <table className="w-full table-auto border-collapse border border-gray-600">
              <thead className="bg-gray-700">
                <tr>
                  <th className="py-3 px-4 border border-gray-600 text-left text-sm font-medium text-gray-100 uppercase tracking-wide">Rank</th>
                  <th className="py-3 px-4 border border-gray-600 text-left text-sm font-medium text-gray-100 uppercase tracking-wide">User</th>
                  <th className="py-3 px-4 border border-gray-600 text-left text-sm font-medium text-gray-100 uppercase tracking-wide">Options</th>
                </tr>
              </thead>
              <tbody>
                {topOptions.map((user, index) => (
                  <tr
                    key={user.id}
                    className={`border border-gray-700 ${index % 2 === 0 ? "bg-gray-900" : "bg-gray-800"} hover:bg-gray-700`}
                  >
                    <td className="py-2 px-4 text-sm font-mono">{index + 1}</td>
                    <td className="py-2 px-4 text-sm">{user.username}</td>
                    <td className="py-2 px-4 text-sm">{user.options}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
  

  
          {/* Ads bas */}
          <HighPerformanceAd
            keyId="96e99453a24be0353f2fe26dc0b9b728"
            width={468}
            height={60}
          />
        </main>
      </div>
  
      {/* Footer tout en bas */}
      <Footer />
    </div>
  );
  
}
